import React, { useState, useEffect } from 'react';
import { receptionReportAPI } from '../services/api';
import './Modal.css';

function OCRelatedIRsModal({ ocId, onClose, currentIrId }) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [irs, setIrs] = useState([]);
    const [selectedIR, setSelectedIR] = useState(null);

    useEffect(() => {
        loadData();
    }, [ocId]);

    const loadData = async () => {
        try {
            setLoading(true);
            const response = await receptionReportAPI.getRelatedIRsForOC(ocId);
            setIrs(response.data || []);
            setError(null);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const formatCurrency = (val) => {
        return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(val);
    };

    const formatDate = (dateInt) => {
        if (!dateInt) return '-';
        const str = dateInt.toString();
        if (str.length === 8) {
            return `${str.substring(6, 8)}/${str.substring(4, 6)}/${str.substring(0, 4)}`;
        }
        return dateInt;
    };

    return (
        <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1300 }}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: '900px', maxWidth: '95%', maxHeight: '90vh', overflow: 'auto' }}>
                <div className="modal-header">
                    <h2>Informes de Recepción para OC #{ocId}</h2>
                    <button className="close" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    {loading && <div className="loading">Cargando...</div>}
                    {error && <div className="alert alert-error">{error}</div>}

                    {!loading && !error && irs.length === 0 && (
                        <p style={{ textAlign: 'center', padding: '20px' }}>No hay informes vinculados a esta OC.</p>
                    )}

                    {!loading && !error && irs.length > 0 && (
                        <div>
                            <p style={{ marginBottom: '15px', color: '#666' }}>
                                Se encontraron <strong>{irs.length}</strong> informes de recepción que recibieron artículos de esta OC:
                            </p>

                            {irs.map((ir) => (
                                <div key={ir.irHId} className="card" style={{
                                    marginBottom: '15px',
                                    border: ir.irHId === currentIrId ? '2px solid #007bff' : '1px solid #ddd',
                                    background: ir.irHId === currentIrId ? '#f0f7ff' : '#fff'
                                }}>
                                    <div style={{ padding: '15px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <div>
                                                <strong style={{ fontSize: '1.1em' }}>IR #{ir.irHId}</strong>
                                                {ir.irHId === currentIrId && (
                                                    <span className="badge badge-info" style={{ marginLeft: '10px' }}>Actual</span>
                                                )}
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                                <div><strong>{formatCurrency(ir.total_received_value || 0)}</strong></div>
                                                <small style={{ color: '#666' }}>Total recibido en este IR</small>
                                            </div>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '10px', fontSize: '0.9em' }}>
                                            <div>
                                                <label style={{ color: '#666' }}>Fecha:</label>
                                                <div>{formatDate(ir.irHDate)}</div>
                                            </div>
                                            <div>
                                                <label style={{ color: '#666' }}>Usuario:</label>
                                                <div>{ir.irHUser || '-'}</div>
                                            </div>
                                            <div>
                                                <label style={{ color: '#666' }}>Proveedor:</label>
                                                <div>{ir.supplier_name || '-'}</div>
                                            </div>
                                        </div>

                                        <button
                                            className="btn btn-sm btn-secondary"
                                            onClick={() => setSelectedIR(selectedIR === ir.irHId ? null : ir.irHId)}
                                        >
                                            {selectedIR === ir.irHId ? '▼ Ocultar Detalle' : '▶ Ver Detalle'}
                                        </button>

                                        {selectedIR === ir.irHId && ir.details && ir.details.length > 0 && (
                                            <div style={{ marginTop: '15px' }}>
                                                <table className="table" style={{ fontSize: '0.85em' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Línea OC</th>
                                                            <th>Artículo</th>
                                                            <th className="text-right">Cant. Recibida</th>
                                                            <th className="text-right">Precio Unit.</th>
                                                            <th className="text-right">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {ir.details.map((d, idx) => (
                                                            <tr key={idx}>
                                                                <td>#{d.oc_line}</td>
                                                                <td>
                                                                    <div>{d.article_description || '-'}</div>
                                                                    <small style={{ color: '#666' }}>{d.article_code}</small>
                                                                </td>
                                                                <td className="text-right">{d.irDReceivedQuantity}</td>
                                                                <td className="text-right">{formatCurrency(d.oc_price || 0)}</td>
                                                                <td className="text-right">{formatCurrency(d.total_valued || 0)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="modal-actions">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OCRelatedIRsModal;
